<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.finish') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.finish"
                :error-messages="finishErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.important') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.important"
                :error-messages="importantErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.init') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.init"
                :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.waiting') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.waiting"
                :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.process') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.process"
                :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'TicketstatusForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
  },
  data() {
    return {
        name: null,
        namefr: null,
        init: null,
        finish: null,
    };
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    initErrors() {
      const errors = [];
      if (!this.$v.item.init.$dirty) return errors;
      has(this.violations, 'init') && errors.push(this.violations.init);
      return errors;
    },
    finishErrors() {
      const errors = [];
      if (!this.$v.item.finish.$dirty) return errors;
      has(this.violations, 'finish') && errors.push(this.violations.finish);
      return errors;
    },
    importantErrors() {
      const errors = [];
      if (!this.$v.item.important.$dirty) return errors;
      has(this.violations, 'important') && errors.push(this.violations.important);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      init: {

      },
      finish: {

      },
      important: {

      },
    }
  }
};
</script>
